import React from 'react';
import "../../css/dashboardStylings/DashboardGardenSnapshotStyling.css";
import totalGardensIcon from '../../images/icons/totalGardensIcon.png';
import totalPlantsIcon from '../../images/icons/totalPlantsIcon.png';
import readyForPlantingIcon from '../../images/icons/readyForPlantingIcon.png';
import readyForHarvestIcon from '../../images/icons/readyForHarvestIcon.png';
import communityNotificationsIcon from '../../images/icons/communityNotificationsIcon.png';

import { ReactComponent as ReadyForHarvestSVG } from '../../images/icons/svgs/GardenDashboardHarvestSVG.svg';
import { ReactComponent as CommunityNotificationsSVG } from '../../images/icons/svgs/GardenDashboardNotificationSVG.svg';
import { ReactComponent as ReadyForPlantingSVG } from '../../images/icons/svgs/GardenDashboardPlantingSVG.svg';
import { ReactComponent as TotalPlantsSVG } from '../../images/icons/svgs/GardenDashboardTotalPlantsSVG.svg';
import { ReactComponent as TotalGardensSVG } from '../../images/icons/svgs/GardenDashboardTotalGardensSVG.svg';


// Icon wrapper component that uses SVG with PNG fallback
const IconWithFallback = ({ SvgComponent, fallbackSrc, alt, className }) => {
    const [error, setError] = React.useState(false);

    if (error) {
        return <img src={fallbackSrc} alt={alt} className={className} />;
    }

    try {
        return (
            <SvgComponent
                className={className}
                aria-label={alt}
                onError={() => setError(true)}
            />
        );
    } catch (err) {
        return <img src={fallbackSrc} alt={alt} className={className} />;
    }
};

const DashboardGardenSnapshotComponent = ({ gardenMap }) => {

    //tallies plants from all gardens
    const tallyPlants = (gardens) => {
        if (!gardens || gardens.length === 0) {
            return 0;
        }

        return gardens.reduce((total, garden) => {
            return total + (garden.plants?.length || 0);
        }, 0);
    }

    const tallyUnplanted = (gardens) => {
        if (!gardens || gardens.length === 0) {
            return 0;
        }

        return gardens.reduce((total, garden) => {
            if (!garden.plants) return total;

            const unplantedCount = garden.plants.filter(plant =>
                plant.planted_date === null
            ).length;

            return total + unplantedCount;
        }, 0);
    }

    const tallyHarvestable = (gardens) => {
        if (!gardens || gardens.length === 0) {
            return 0;
        }

        return gardens.reduce((total, garden) => {
            if (!garden.plants) return total;

            const harvestableCount = garden.plants.filter(plant =>
                plant.plant_status === 'harvestable'
            ).length;

            return total + harvestableCount;
        }, 0);
    }

    const totalPlants = tallyPlants(gardenMap);
    const unplantedPlants = tallyUnplanted(gardenMap);
    const harvestablePlants = tallyHarvestable(gardenMap);

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        });

        const icons = document.querySelectorAll('.snapshot-card-icon');
        icons.forEach(icon => observer.observe(icon));

        return () => observer.disconnect();
    }, []);

    return (
        <div className={`snapshot-component-body`}>
            <div className={`snapshot-card`}>
                <div className={`snapshot-card-content`}>
                    <IconWithFallback
                        SvgComponent={TotalGardensSVG}
                        fallbackSrc={totalGardensIcon}
                        alt="Total Gardens"
                        className={`snapshot-card-icon`}
                    />
                    <div className={`snapshot-card-info`}>
                        <div className={`snapshot-card-number`}>{gardenMap.length || 0}</div>
                        <div className={`snapshot-card-text`}>Total Gardens</div>
                    </div>
                </div>
            </div>

            <div className={`snapshot-card`}>
                <div className={`snapshot-card-content`}>
                    <IconWithFallback
                        SvgComponent={TotalPlantsSVG}
                        fallbackSrc={totalPlantsIcon}
                        alt="Total Plants"
                        className={`snapshot-card-icon`}
                    />
                    <div className={`snapshot-card-info`}>
                        <div className={`snapshot-card-number`}>{totalPlants}</div>
                        <div className={`snapshot-card-text`}>Total Plants</div>
                    </div>
                </div>
            </div>

            <div className={`snapshot-card`}>
                <div className={`snapshot-card-content`}>
                    <IconWithFallback
                        SvgComponent={ReadyForPlantingSVG}
                        fallbackSrc={readyForPlantingIcon}
                        alt="Ready for Planting"
                        className={`snapshot-card-icon`}
                    />
                    <div className={`snapshot-card-info`}>
                        <div className={`snapshot-card-number`}>{unplantedPlants}</div>
                        <div className={`snapshot-card-text`}>Ready for Planting</div>
                    </div>
                </div>
            </div>

            <div className={`snapshot-card`}>
                <div className={`snapshot-card-content`}>
                    <IconWithFallback
                        SvgComponent={ReadyForHarvestSVG}
                        fallbackSrc={readyForHarvestIcon}
                        alt="Ready for Harvest"
                        className={`snapshot-card-icon`}
                    />
                    <div className={`snapshot-card-info`}>
                        <div className={`snapshot-card-number`}>{harvestablePlants}</div>
                        <div className={`snapshot-card-text`}>Ready for Harvest</div>
                    </div>
                </div>
            </div>

            <div className={`snapshot-card`}>
                <div className={`snapshot-card-content`}>
                    <IconWithFallback
                        SvgComponent={CommunityNotificationsSVG}
                        fallbackSrc={communityNotificationsIcon}
                        alt="Community Notifications"
                        className={`snapshot-card-icon`}
                    />
                    <div className={`snapshot-card-info`}>
                        <div className={`snapshot-card-number`}>0</div>
                        <div className={`snapshot-card-text`}>Community Notifications</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardGardenSnapshotComponent;